import React from "react";
import styled from "styled-components";
import { eventEmitter } from "../../../services";
import { EVT_KEYDOWN } from "../../../lib/events";
import { KEY_ESC } from "../../../lib/keyboard";

const Container = styled.div`
    z-index: 100;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`;
const Overlay = styled.div`
    z-index: 10;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: #000;
    opacity: 0.5;
`;

const Image = styled.img`
    z-index: 1000;
    padding: 20px;
    max-width: 95%;
    max-height: 90%;
    background-color: #fff;
`;

type Props = {};
type State = {
    src: string;
    show: boolean;
};

export default class Preview extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            src: "",
            show: false,
        };
    }

    componentDidMount() {
        eventEmitter.on("pageContents.showImg", this.onShow);
        window.addEventListener(EVT_KEYDOWN, this.onKeyDown);
    }

    componentWillUnmount() {
        eventEmitter.off("pageContents.showImg", this.onShow);
        window.removeEventListener(EVT_KEYDOWN, this.onKeyDown);
    }

    onShow = (src: string) => {
        this.setState({
            src,
            show: true,
        });
    };

    onHide = () => this.setState({ src: "", show: false });

    onKeyDown = (evt: KeyboardEvent) => {
        if (evt.key === KEY_ESC) {
            this.onHide();
        }
    };

    onClick = (evt: React.MouseEvent<HTMLElement>) => {
        if ((evt.target as HTMLElement).nodeName !== "img") {
            this.onHide();
        }
    };

    render() {
        if (!this.state.show) {
            return null;
        }

        return (
            <Container onClick={this.onClick}>
                <Overlay />
                <Image src={this.state.src} />
            </Container>
        );
    }
}
